export const TYPE_NEWS = 0
export const TYPE_ARTICLE = 1
export const TYPE_EDITORIAL = 2
export const TYPE_HEADLINE = 3
export const TYPE_BREAKING_NEWS = 4
